module.exports = __webpack_public_path__ + "static/media/promo.6e83685a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/vid/promo.mp4
// module id = 125
// module chunks = 0